import { useTranslation } from 'react-i18next'

interface Props {
  steps: string[]
  currentStep: string
  isCoapplicant?: boolean
}

const StepProgressionBar = ({ steps, currentStep, isCoapplicant = false }: Props) => {
  const { t } = useTranslation()
  const stepIndex = steps.indexOf(currentStep) + 1
  return (
    <ul className="steps">
      {steps.includes('personal-information') && (
        <li className="personal-information">
          <a href="step_4.html">
            <i className="fa-light fa-circle-user" />
            <div className="step-info">
              <p>
                {t('common.step')} {stepIndex}
              </p>
              <h4>
                <span>
                  {t('common.step')} {stepIndex} -{' '}
                </span>
                {isCoapplicant ? t('common.aboutCoapplicant') : t('common.aboutYourself')}
              </h4>
            </div>
          </a>
        </li>
      )}
      {steps.includes('employment') && (
        <li className="employment">
          <a href="step_6.html">
            <i className="fa-light fa-money-check-dollar-pen" />
            <div className="step-info">
              <p>
                {t('common.step')} {stepIndex}
              </p>
              <h4>
                <span>
                  {t('common.step')} {stepIndex} -{' '}
                </span>
                {t('common.annualIncome')}
              </h4>
            </div>
          </a>
        </li>
      )}
      {steps.includes('address') && (
        <li className="address">
          <a href="step_7.html">
            <i className="fa-light fa-map-location-dot" />
            <div className="step-info">
              <p>
                {t('common.step')} {stepIndex}
              </p>
              <h4>
                <span>
                  {t('common.step')} {stepIndex} -{' '}
                </span>
                {t('common.yourHome')}
              </h4>
            </div>
          </a>
        </li>
      )}
      {steps.includes('review') && (
        <li className="recap">
          <a href="step_8.html">
            <i className="fa-light fa-clipboard-list-check" />
            <div className="step-info">
              <p>
                {t('common.step')} {stepIndex}
              </p>
              <h4>
                <span>
                  {t('common.step')} {stepIndex} -{' '}
                </span>
                {t('common.review')}
              </h4>
            </div>
          </a>
        </li>
      )}
    </ul>
  )
}

export default StepProgressionBar
